<div class="footer-button-container">
  <div>
    @if (!ppCancelText) {
      <pp-button-modal-cancel
        [class.modalCancelButton--hidden]="ppHideCancel"
        [ppDataTarget]="ppCancelDataTarget"
        ppId="modalCancelButton"
        (ppAction)="cancel()"
      >
        {{ 'cancel' | ppTranslate }}
      </pp-button-modal-cancel>
    }
  </div>

  <div class="footer-button-container--right">
    @if (ppCancelText) {
      <button
        class="footer-button-container--right__button"
        [attr.data-test]="'modalCustomCancelButton'"
        (click)="cancel()"
      >
        {{ ppCancelText }}
      </button>
    }
    <pp-button-modal-confirm
      ppTooltip
      [ppTitle]="ppConfirmTooltip"
      [ppDataTarget]="ppConfirmDataTarget"
      (ppAction)="confirm()"
      [ppDisabled]="ppDisabled"
      [ppError]="ppError"
      [ppProcess]="ppProcess"
    >
      {{ ppConfirmText }}
    </pp-button-modal-confirm>
  </div>
</div>
